import { render, staticRenderFns } from "./guessingGamePersonalDetail.vue?vue&type=template&id=d1f35348&scoped=true"
import script from "./guessingGamePersonalDetail.vue?vue&type=script&lang=ts"
export * from "./guessingGamePersonalDetail.vue?vue&type=script&lang=ts"
import style0 from "./guessingGamePersonalDetail.vue?vue&type=style&index=0&id=d1f35348&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f35348",
  null
  
)

export default component.exports